import { useEffect } from "react";
import { MessageSquareText, ListChecks, Puzzle } from "lucide-react";
import { Advisor } from "@/advisor/Advisor";
import { DemoGallery } from "@/advisor/DemoGallery";
import { usePageMeta } from "@/lib/usePageMeta";
import { trackOpen } from "@/advisor/api";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { TrustLine, TrustSection } from "@/advisor/AdvisorTrust";

const Hero = () => (
  <div className="mb-7 sm:mb-9">
    <p className="adv-eyebrow mb-4" data-testid="product-name">LiveMedia Business Advisor</p>
    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.08] text-[#F3EEE4]">
      Biznesiniz üçün <span className="text-[#D6AD62]">nə yarada</span> bilərik?
    </h1>
    <p className="text-[#cfc9bd] mt-4 text-base sm:text-lg max-w-xl leading-relaxed">
      Biznesinizi qısaca təsvir edin. Sizə uyğun rəqəmsal həlləri müəyyən edək.
    </p>
  </div>
);

const HOW = [
  { Icon: MessageSquareText, t: "Biznesinizi yazın", d: "Bir cümlə kifayətdir" },
  { Icon: ListChecks, t: "Uyğun həlləri görün", d: "Mini demo ilə sınayın" },
  { Icon: Puzzle, t: "Layihənizi yığın", d: "Pulsuz qiymət təklifi alın" },
];

export default function AdvisorPage() {
  usePageMeta("Business Advisor", "Biznesinizə uyğun rəqəmsal həlləri 1 dəqiqədə kəşf edin. Pulsuz, qeydiyyatsız.");
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const ad = p.get("utm_source") || (p.get("gclid") ? "google" : p.get("fbclid") ? "facebook" : "");
    trackOpen(ad ? "ad" : "page", ad);
  }, []);
  useEffect(() => {
    if (window.location.hash === "#demo") document.getElementById("demo")?.scrollIntoView();
  }, []);
  return (
    <div data-testid="advisor-page">
      <section className="adv-stage pt-[120px] pb-20 min-h-[100svh]">
        <div className="absolute inset-0 adv-grid [mask-image:linear-gradient(to_bottom,black,transparent)] pointer-events-none" />
        <div className="relative container-lm">
          <AdvisorBody />
        </div>
      </section>
      <TrustSection />
      <section className="container-lm pt-16">
        <div className="grid sm:grid-cols-3 gap-3">
          {HOW.map(({ Icon, t, d }, i) => (
            <div key={t} className="rounded-2xl bg-white/70 border border-[#171715]/5 p-5 flex items-center gap-4">
              <span className="font-display text-sm text-[#171715]/30">0{i + 1}</span>
              <Icon size={22} className="text-[#b58a3f]" />
              <div><div className="font-semibold">{t}</div><div className="text-sm text-[#77736B]">{d}</div></div>
            </div>
          ))}
        </div>
      </section>
      <DemoGallery />
    </div>
  );
}

const AdvisorBody = () => {
  const { state } = useAdvisor();
  return (
    <div className={state.step === "results" ? "" : "max-w-3xl"}>
      <Advisor hero={<Hero />} footer={<TrustLine />} />
    </div>
  );
};
